import React, { FC } from 'react'
// import { toast } from 'react-toastify'
import { DepositBank } from '../../@types/prefix'
import { getBankColor, getBankName, Banks } from '../../helpers/bank'
import { Button, Typography, message } from 'antd'
import { CopyOutlined } from '@ant-design/icons';

const { Text } = Typography

interface BankDepositItemProps {
	bank: DepositBank
}
const BankDepositItem: FC<BankDepositItemProps> = ({ bank }) => {
	const [messageApi, contextHolder] = message.useMessage();
	const copyAccountNumber = () => {
		navigator.clipboard.writeText(bank.accountNumber)
		messageApi.open({
			type: 'success',
			content: 'คัดลอกเลขที่บัญชีสำเร็จ',
		});
	}

	return (
		<>
			{contextHolder}
			<div className="bank-deposit-card" style={{ marginBottom: 16 }}>
				<div
					className="bank-card-logo"
					style={{ boxShadow: `0 8px 12px -4px ${getBankColor(bank.bank)}` }}
				>
					<img
						src={Banks.filter(bankName => bankName.key === bank?.bank.toUpperCase())[0].image}
						alt={getBankName(bank.bank)}
					/>
				</div>
				<div className="bank-card-info">
					<div><Text type="secondary"><small>{getBankName(bank.bank)}</small></Text></div>
					<Text className="bank-deposite-account">{bank.accountNumber}</Text>
					<div><Text type="secondary"><small>{bank.accountName}</small></Text></div>
				</div>
				<Button
					type="primary"
					onClick={copyAccountNumber}
					style={{ display: 'block', height: 'auto', marginLeft: 'auto' }}
				>
					<CopyOutlined rev="" />
					<div><small>คัดลอก</small></div>
				</Button>
			</div>
		</>
	)
}

export default BankDepositItem
